import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import { useEntidad, useManagedContext } from "../../hooks"
import ReciboPublicacionModal from "../ReciboPublicacionModal"
const RegistrosIngresosPublicosGridModal = ({ idPagoRendicionLote, onCancel }) => {
    
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [pagosRendiciones, setPagosRendiciones] = useState([])
    const [lotes, setLotes] = useState([])
    const [reciboPublicacion, setReciboPublicacion] = useState(null)

    const [, getRowEntidad] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: {
            key: 'Recaudadora',
            timeout: 0
        }
    })

    useEffect(() => {
        if (idPagoRendicionLote > 0) {
            SearchRecuadaciones(idPagoRendicionLote)
        }
    }, [])

    const fetchLote = (id) => new Promise((resolve, reject) => {
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECAUDACION_LOTE,
            `/${id}`,
            null,
            res => res.json().then(resolve),
            res => reject(res),
            err => reject(err),
        )
    })

    const SearchLotes = (data) => {
        const idsRecaudacionLote = [...new Set(
            data
                .map(item => item.recaudacion?.idRecaudacionLote)
                .filter(Boolean)
        )]

        if (idsRecaudacionLote.length === 0) {
            setIsLoading(false)
            return
        }

        Promise.all(idsRecaudacionLote.map(fetchLote))
            .then(result => {
                setLotes(result)
                setIsLoading(false)
            })
            .catch(err => {
                onRequestError(err)
                setIsLoading(false)
            })
    }

    const SearchRecuadaciones = (idPagoRendicionLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idPagoRendicionLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PAGO_RENDICION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setPagosRendiciones(data)
                SearchLotes(data)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.codigoDelegacion && item.numeroRecibo) {
                setReciboPublicacion({
                    codigoDelegacion: item.codigoDelegacion,
                    numeroRecibo: item.numeroRecibo,
                })
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title="Rendiciones de pago"
            body={(
                <>
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={lotes}
                    columns={[
                        { Header: 'N° lote recaudación', accessor: 'numeroLote', width: '40%' },
                        { Header: 'Recaudadora', accessor: 'idRecaudadora', width: '40%', Cell: ({ value }) => getRowEntidad('Recaudadora', value)?.nombre ?? '' },
                        { Header: 'Casos', accessor: 'id', width: '20%', Cell: ({ value }) => new Set(pagosRendiciones.filter(r => r.recaudacion?.idRecaudacionLote === value).map(r => getNumeroRecibo_ObjectToIdentificador(r)).filter(Boolean)).size },
                    ]}
                    showFilterGlobal={false}
                    showDownloadCSV={false}
                />

                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={pagosRendiciones}
                    avmr={avmr}
                    columns={[
                        { Header: 'N° VEP', accessor: 'numeroRecibo', width: '12.5%', Cell: ({ row }) =>  getNumeroRecibo_ObjectToIdentificador(row.original) },
                        { Header: 'Fecha de Cobro', accessor: 'fechaPago', Cell: (data) => getDateToString(data.value), width: '15%'},
                        { Header: 'Importe', accessor: 'importePago', Cell: (data) => getFormatNumber(data.value, 2), width: '12.5%', alignCell: 'right' },
                        { Header: 'Recaudadora', accessor: 'recaudacion', width: '10%', Cell: ({ row }) => getRowEntidad('Recaudadora', lotes.find(l => l.id === row.original.recaudacion?.idRecaudacionLote)?.idRecaudadora)?.nombre ?? '' },
                        { Header: 'Código de barras', accessor: 'codigoBarras', width: '30%' },

                    ]}
                    showDownloadCSV={false}
                />

                {reciboPublicacion && (
                    <ReciboPublicacionModal
                        codigoDelegacion={reciboPublicacion?.codigoDelegacion}
                        numeroRecibo={reciboPublicacion?.numeroRecibo}
                        onCancel={() => setReciboPublicacion(null)}
                    />
                )}
                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default RegistrosIngresosPublicosGridModal
